import React from 'react'

const AboutSection = () => {
  return (
    <div className='home-about-section'>
     <div className="container my-5">
  <div className="row d-flex align-content-center">
    <div className="col-lg-6">
      <img
        className="w-100 shadow"
        src="images/user-centric.png"
        alt="Placeholder"
      />
    </div>
    <div className="col-lg-6">
      <div className="p-5 mt-4">
        <h1 className="display-6">Customer-Centric Approach</h1>
        <p className="lead">
         Our clients are at the core of our business. We are proud to offer specialized consultation and customized solutions that address the unique challenges of each project, ensuring that our customers receive unmatched service and support in every aspect of their power management needs.
        </p>
        <a href="/" className="btn">
          Read More
        </a>
      </div>
    </div>
  </div>
  <div className="row">
    <div className="col-lg-6">
      <div className="p-5 mt-4">
        <h1 className="display-6">Innovation and Expertise</h1>
        <p className="lead">
        At <b>Conwave Power Solution</b>, we are committed to continuous innovation and delivering cutting-edge solutions. From in-house manufacturing and design of LT Electrical Switchboards, Control & Relay Panels, and APFCR Panels to DG Synchronization Panels, we combine industry expertise with advanced technology to create reliable and future-ready systems.
        </p>
        <a href="/" className="btn">
          Read More
        </a>
      </div>
    </div>
    <div className="col-lg-6">
      <img
        className="w-100 shadow"
        src="images/innovation-experties.png"
        alt="Placeholder"
      />
    </div>
  </div>
  <div className="row">
    <div className="col-lg-6">
      <img
        className="w-100 shadow"
        src="images/precision-and-excellence.png"
        alt="Placeholder"
      />
    </div>
    <div className="col-lg-6">
      <div className="p-5 mt-4">
        <h1 className="display-6">Precision and Excellence</h1>
        <p className="lead">
         We believe in delivering excellence through precision. Our in-house PLC & SCADA programming services are designed to meet the exacting needs of industry-level automation, ensuring seamless and efficient operations for our clients.
        </p>
        <a href="/" className="btn">
          Read More
        </a>
      </div>
    </div>
  </div>
  <div className="row">
    <div className="col-lg-6">
      <div className="p-5 mt-4">
        <h1 className="display-6">Commitment to Sustainability</h1>
        <p className="lead">
         Sustainability is at the heart of what we do. Whether it's synchronizing Diesel and Gas Generators with utility systems or providing On-Grid, Off-Grid, and Hybrid Solar Solutions, Conwave Power Solution is dedicated to driving energy efficiency and supporting the transition to clean, renewable power sources.


        </p>
        <a href="/" className="btn">
          Read More
        </a>
      </div>
    </div>
    <div className="col-lg-6">
      <img
        className="w-100 shadow"
        src="images/sustainability.png"
        alt="Placeholder"
      />
    </div>
  </div>
</div>


    </div>
  )
}

export default AboutSection
